import { CirclePlay } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SettingsStore from "@/stores/SettingsStore";

export default function RedirectToAvatarButton() {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const brandingPlayLogoUrl = SettingsStore(state => state.brandingPlayLogoUrl);
  const brandingPlayLogoHoverUrl = SettingsStore(state => state.brandingPlayLogoHoverUrl);
  const handleRedirect = () => {
    window.open("/avatar", "_blank", "noopener,noreferrer");
  };

  const hasBrandedImage = !!brandingPlayLogoUrl;
  const hasHoverImage = !!brandingPlayLogoHoverUrl;

  return (
    <motion.button
      className="p-2 rounded-md flex items-center gap-3 bg-white transition-colors duration-200 ease-in-out focus:outline-none hover:bg-muted"
      aria-label="Play"
      transition={{ duration: 0.2 }}
      autoFocus
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      onClick={handleRedirect}
    >
      <div className="w-6 aspect-square flex items-center justify-center relative">
        {hasBrandedImage ? (
          hasHoverImage ? (
            <AnimatePresence mode="wait">
              <motion.img
                key={isHovered ? "hover" : "default"}
                src={isHovered ? brandingPlayLogoHoverUrl : brandingPlayLogoUrl}
                alt="Start"
                className="h-full w-full rounded-full absolute inset-0"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.2 }}
              />
            </AnimatePresence>
          ) : (
            <motion.img
              src={brandingPlayLogoUrl}
              alt="Start"
              className="h-full w-full rounded-full"
              initial={false}
              animate={{ rotate: isHovered ? -28 : 0 }}
              transition={{ duration: 0.2 }}
            />
          )
        ) : (
          <motion.div
            initial={false}
            animate={{ rotate: isHovered ? -28 : 0 }}
            transition={{ duration: 0.2 }}
            className="h-full w-full flex items-center justify-center"
          >
            <CirclePlay className="h-full w-full text-muted-foreground" strokeWidth={1.5} />
          </motion.div>
        )}
      </div>
      {t('common.avatar')}
    </motion.button>
  );
}
